class VgJoiningGtm {
	constructor() {
		// Initialization if needed
	}

	/**
	 * USER ID Tracking in GTM Google Tag Manager:
	 *
	 * @param {*} eventName defined in GTM ej: "Registro_usuario_nuevo"
	 * @param {*} userId (crm vivagym) externalId in Exerp
	 */
	//
	static pushUserIdToDataLayer(eventName, userId) {
		console.log("gtm-userId-tracking: Pushing data to GTM:", {
			eventName,
			userId,
		});
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
		window.dataLayer.push({
			event: eventName,
			userId: userId,
		});
	}

	static pushToDataLayer(eventName, extraData = {}) {
		window.dataLayer = window.dataLayer || [];
		// Clear the previous ecommerce object.
		window.dataLayer.push({ ecommerce: null });
		
		// Create the object to push to dataLayer.
		const eventData = {
			event: eventName,
			ecommerce: {
				items: [] // Initialize as an empty array.
			}
		};
	
		// If extraData has items, spread them into the eventData object.
		if (extraData.ecommerce && extraData.ecommerce.items) {
			eventData.ecommerce.items = extraData.ecommerce.items;
		}
	
		window.dataLayer.push(eventData);
		console.log("gtm-tracking: Pushing data to GTM:", { eventData  });
	}
}

export { VgJoiningGtm };
